import { LocaleRelativeTime } from '@mi-front/ui';
import { Typography } from '@mui/material';
import { defineMessage, FormattedMessage, useIntl } from 'react-intl';

const noLastSeenMessage = defineMessage({
  id: 'fleet.devices.card.noLastSeen',
  defaultMessage: 'Nunca visto en línea',
});

const lastSeenMessage = defineMessage({
  id: 'fleet.devices.card.lastSeen',
  defaultMessage: 'Visto por última vez {relativeTime}',
});

/**
 * Relative "last seen online" caption for offline devices only.
 * Hidden when the device is online.
 */
export function BalenaDeviceCardLastSeen({
  isOnline,
  lastSeenOnline,
}: {
  isOnline: boolean;
  lastSeenOnline?: string;
}) {
  const { $t } = useIntl();

  if (isOnline) {
    return null;
  }

  if (!lastSeenOnline) {
    return (
      <Typography variant="caption" color="text.disabled">
        {$t(noLastSeenMessage)}
      </Typography>
    );
  }

  return (
    <Typography
      variant="caption"
      color="text.disabled"
      title={new Date(lastSeenOnline).toLocaleString()}
    >
      <FormattedMessage
        {...lastSeenMessage}
        values={{
          relativeTime: <LocaleRelativeTime value={lastSeenOnline} />,
        }}
      />
    </Typography>
  );
}
